export const SocialData = [
    {
        platform: "Instagram",
        link : "https://www.instagram.com/viizhnu/",
        icon: require("../../assets/instagram.png")
    },
    {
        platform: "Github",
        link : "https://github.com/vishnugprasad",
        icon: require("../../assets/github.png")
    },
    {
        platform: "Facebook",
        link : "https://www.facebook.com/vishnuanugraha001/",
        icon: require("../../assets/facebook.png")
    },
    {
        platform: "Linkedin",
        link : "https://www.linkedin.com/in/vishnu-g-prasad-2ab651237/",
        icon: require("../../assets/linkedin.png")
    },
    {
        platform: "Leetcode",
        link : "https://leetcode.com/vishnugprasad/",
        icon: require("../../assets/leetcode.png")
    },
];